<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleAlert, handleConfirm } from "@/components/UtilsIf";

export default {
  name: "teamPerformanceDetail",
  components: { breadcrumbs },
  data() {
    return {
      form: {}
    };
  },
  methods: {
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    /**
     * 详情
     * @param row
     */
    detail(row = {}) {
      this.$router.push({
        path: "/staff/teamperformance/teamPerformancePersonDetail",
        query: {
          id: row.id
        }
      });
    },
    /**
     * 转正
     * @param row
     */
    confirmed(row = {}) {
      handleConfirm(`是否将${row.title || "--"}转正为正式组员?`, "info")
        .then(() => {
          handleAlert("员工已成功转正", "success");
        })
        .catch(() => {});
    },
    /**
     * 移除
     * @param row
     */
    remove(row = {}) {
      handleConfirm(
        `是否将${row.title ||
          "--"}从小组中移除?移除后该成员将无法获得绩效数据!`,
        "warning"
      )
        .then(() => {
          handleAlert("成员已从小组中移除，成员历史数据将保留组内", "success");
        })
        .catch(() => {});
    }
  }
};
</script>

<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.back()"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <!-- 信息 -->
    <div class="color0063ea fw-600 mgb-10">基础信息</div>
    <el-descriptions border :column="4">
      <el-descriptions-item label="团队名称"
        >{{ form.userName }}
      </el-descriptions-item>
      <el-descriptions-item label="团队管理者"
        >{{ form.userPhone }}
      </el-descriptions-item>
      <el-descriptions-item label="团队类型"
        >{{ form.identityCard }}
      </el-descriptions-item>
      <el-descriptions-item label="团队状态"
        >{{ form.particularDesc }}
      </el-descriptions-item>
      <el-descriptions-item label="团队总人数（人）"
        >{{ form.userName }}
      </el-descriptions-item>
      <el-descriptions-item label="团队总绩效（元）"
        >{{ form.userPhone }}
      </el-descriptions-item>
      <el-descriptions-item label="团队充值订单总数（笔）"
        >{{ form.identityCard }}
      </el-descriptions-item>
      <el-descriptions-item label="团队创建时间"
        >{{ form.particularDesc }}
      </el-descriptions-item>
    </el-descriptions>
    <div class="flex aic jcsb mgb-10 mgt-10">
      <div class="color0063ea fw-600 ">团队详情</div>
      <div>
        成员姓名：
        <el-select
          v-model="form.status"
          placeholder="成员姓名"
          clearable
          style="margin-left: 10px"
        >
          <el-option label="正常" :value="0"></el-option>
          <el-option label="冻结" :value="1"></el-option>
          <el-option label="锁定" :value="2"></el-option>
        </el-select>
      </div>
    </div>
    <el-button type="text" size="small" @click="detail()">转正 </el-button>
    <customTable
      ref="customTable"
      :api="undefined"
      :params="form"
      :isMounted="false"
    >
      <template #columns>
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="partnerNum" label="姓名"></el-table-column>
        <el-table-column prop="userName" label="手机号"></el-table-column>
        <el-table-column
          prop="partnerNum"
          label="所属二级团队"
        ></el-table-column>
        <el-table-column prop="userName" label="职位"></el-table-column>
        <el-table-column prop="partnerNum" label="员工状态"></el-table-column>
        <el-table-column
          prop="userName"
          label="总绩效实付（元）"
        ></el-table-column>
        <el-table-column
          prop="partnerNum"
          label="充值订单数（笔）"
        ></el-table-column>
        <el-table-column
          prop="userName"
          label="提成总额（元）"
        ></el-table-column>

        <el-table-column fixed="right" label="操作" width="120">
          <template #default="{row}">
            <el-button type="text" size="small" @click="detail(row)"
              >详情
            </el-button>
            <el-button type="text" size="small" @click="confirmed(row)"
              >转正
            </el-button>
            <el-button type="text" size="small" @click="remove(row)"
              >移除
            </el-button>
          </template>
        </el-table-column>
      </template></customTable
    >
  </div>
</template>

<style scoped lang="scss"></style>
